// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   Container,
//   Typography,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   IconButton,
//   InputAdornment,
// } from "@mui/material";
// import { Search, Delete } from "@mui/icons-material";
// import axios from "axios";

// const ModifyClassResults = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { schoolId } = location.state || {};
//   const [className, setClassName] = useState("");
//   const [subject, setSubject] = useState("");
//   const [stream, setStream] = useState("");
//   const [term, setTerm] = useState("Term 1");
//   const [examType, setExamType] = useState("Opener Exam");
//   const [examNames, setExamNames] = useState([]);
//   const [selectedExamName, setSelectedExamName] = useState("");
//   const [fetchingExamNames, setFetchingExamNames] = useState(false);
//   const [learners, setLearners] = useState([]);
//   const [allLearners, setAllLearners] = useState([]);
//   const [marks, setMarks] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [fetchingLearners, setFetchingLearners] = useState(false);
//   const [schoolStreams, setSchoolStreams] = useState({});
//   const [fetchingStreams, setFetchingStreams] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [sortBy, setSortBy] = useState("admissionNumber");

//   const getClasses = () => [
//     "PG",
//     "PP1",
//     "PP2",
//     "Grade 1",
//     "Grade 2",
//     "Grade 3",
//     "Grade 4",
//     "Grade 5",
//     "Grade 6",
//     "Grade 7",
//     "Grade 8",
//     "Grade 9",
//     "Grade 10",
//     "Grade 11",
//     "Grade 12",
//   ];

//   const getSubjectsByClass = (className) => {
//     if (["PG"].includes(className)) {
//       return [
//         "Number Work",
//         "Language/Total",
//         "Reading/Jumla",
//         "Creative",
//         "Science and Environment",
//         "Social Studies and Religious Education",
//       ];
//     }

//     if (["PP1", "PP2"].includes(className)) {
//       return [
//         "Number Work",
//         "Language/Total",
//         "Kiswahili/Jumla",
//         "Creative Arts",
//         "Science and Environment",
//         "Social Studies and Religious Education",
//       ];
//     } else if (["Grade 1", "Grade 2", "Grade 3"].includes(className)) {
//       return [
//         "English",
//         "Kiswahili",
//         "Mathematics",
//         "Science",
//         "Social Studies and Religious Education",
//         "Environmental Activities",
//       ];
//     } else if (["Grade 4", "Grade 5", "Grade 6"].includes(className)) {
//       return [
//         "English Language",
//         "English Composition",
//         "Kiswahili Lugha",
//         "Kiswahili Insha",
//         "Mathematics",
//         "Science and Technology",
//         "Agriculture and Nutrition",
//         "Social Studies",
//         "Religious Education",
//         "Creative Arts & Sports",
//       ];
//     } else if (["Grade 7", "Grade 8", "Grade 9"].includes(className)) {
//       return [
//         "English Language",
//         "English Composition",
//         "Kiswahili Lugha",
//         "Kiswahili Insha",
//         "Mathematics",
//         "Science",
//         "Science and Technology",
//         "Agriculture and Nutrition",
//         "Pre-Technical Studies",
//         "Social Studies",
//         "Religious Education",
//         "Creative Arts & Sports",
//       ];
//     } else if (["Grade 10", "Grade 11", "Grade 12"].includes(className)) {
//       return [
//         "English",
//         "Kiswahili Language/Kenya Sign Language",
//         "Mathematics",
//         "Religious Education",
//         "Science and Technology",
//         "Agriculture and Nutrition",
//         "Social Studies",
//       ];
//     }
//     return [];
//   };

//   useEffect(() => {
//     if (className) {
//       const fetchStreams = async () => {
//         setFetchingStreams(true);
//         try {
//           const streamsResponse = await axios.get(
//             `http://localhost:5000/api/schools/${schoolId}/streams`
//           );
//           if (streamsResponse.data?.classStreams) {
//             setSchoolStreams(streamsResponse.data.classStreams);
//           } else {
//             setSchoolStreams({});
//           }
//         } catch (error) {
//           console.error("Error fetching streams:", error);
//           alert("Failed to fetch streams");
//           setSchoolStreams({});
//         } finally {
//           setFetchingStreams(false);
//         }
//       };
//       fetchStreams();
//     } else {
//       setSchoolStreams({});
//     }
//   }, [className, schoolId]);

//   useEffect(() => {
//     if (className) {
//       const fetchAllLearners = async () => {
//         setFetchingLearners(true);
//         try {
//           const response = await axios.get(
//             "http://localhost:5000/api/schools/learners",
//             {
//               params: { schoolId, className },
//             }
//           );
//           if (Array.isArray(response.data)) {
//             setAllLearners(
//               response.data.filter(
//                 (learner) => learner && learner._id && learner.class
//               )
//             );
//           } else {
//             setAllLearners([]);
//           }
//         } catch (error) {
//           console.error("Error fetching learners:", error);
//           alert("Failed to fetch learners");
//           setAllLearners([]);
//         } finally {
//           setFetchingLearners(false);
//         }
//       };
//       fetchAllLearners();
//     } else {
//       setAllLearners([]);
//     }
//   }, [className, schoolId]);

//   useEffect(() => {
//     if (
//       className &&
//       term &&
//       (examType === "Random Exams" || examType === "Other Exams")
//     ) {
//       const fetchExamNames = async () => {
//         setFetchingExamNames(true);
//         try {
//           const response = await axios.get(
//             `http://localhost:5000/api/schools/${schoolId}/performance`
//           );
//           const examNamesSet = new Set();
//           if (Array.isArray(response.data)) {
//             response.data.forEach((learner) => {
//               if (
//                 !learner ||
//                 learner.class !== className ||
//                 !Array.isArray(learner.results)
//               )
//                 return;
//               learner.results.forEach((result) => {
//                 if (
//                   result &&
//                   result.term === term &&
//                   result.examType === examType
//                 ) {
//                   examNamesSet.add(result.examName || "Unnamed");
//                 }
//               });
//             });
//           }
//           const examNamesArray = Array.from(examNamesSet).sort((a, b) =>
//             a === "Unnamed" ? 1 : b === "Unnamed" ? -1 : a.localeCompare(b)
//           );
//           setExamNames(examNamesArray);
//           setSelectedExamName(
//             examNamesArray.length > 0 ? examNamesArray[0] : ""
//           );
//           if (examNamesArray.length === 0) {
//             alert(`No ${examType} found for ${className}, ${term}.`);
//           }
//         } catch (error) {
//           console.error("Error fetching exam names:", error);
//           alert("Failed to fetch exam names");
//           setExamNames([]);
//         } finally {
//           setFetchingExamNames(false);
//         }
//       };
//       fetchExamNames();
//     } else {
//       setExamNames([]);
//       setSelectedExamName("");
//     }
//   }, [className, term, examType, schoolId]);

//   useEffect(() => {
//     if (
//       stream &&
//       term &&
//       examType &&
//       subject &&
//       Array.isArray(allLearners) &&
//       allLearners.length > 0 &&
//       (examType === "Random Exams" || examType === "Other Exams"
//         ? selectedExamName
//         : true)
//     ) {
//       const hasStreams = schoolStreams[className]?.length > 0;
//       let filteredLearners = allLearners.filter(
//         (learner) => learner.class === className
//       );
//       if (hasStreams) {
//         if (stream === "No Stream") {
//           filteredLearners = filteredLearners.filter(
//             (learner) => !learner.stream || learner.stream.trim() === ""
//           );
//         } else {
//           filteredLearners = filteredLearners.filter(
//             (learner) => learner.stream === stream
//           );
//         }
//       }

//       const fetchResults = async () => {
//         setFetchingLearners(true);
//         try {
//           const learnerIds = filteredLearners
//             .map((learner) => learner._id)
//             .filter((id) => id);
//           if (learnerIds.length === 0) {
//             setLearners([]);
//             setMarks({});
//             alert("No learners found for the selected criteria.");
//             return;
//           }
//           const payload = { learnerIds, term, examType, subject };
//           if (examType === "Random Exams" || examType === "Other Exams") {
//             payload.examName =
//               selectedExamName === "Unnamed" ? null : selectedExamName;
//           }
//           const response = await axios.post(
//             "http://localhost:5000/api/schools/results/class",
//             payload
//           );
//           const results = Array.isArray(response.data.results)
//             ? response.data.results
//             : [];

//           const learnersWithResults = filteredLearners.map((learner) => {
//             const learnerResult = results.find(
//               (r) => r.learnerId === learner._id
//             );
//             return {
//               ...learner,
//               marks:
//                 learnerResult && learnerResult.marks != null
//                   ? learnerResult.marks.toString()
//                   : "",
//             };
//           });

//           let finalLearners = learnersWithResults;
//           if (searchQuery) {
//             finalLearners = finalLearners.filter(
//               (learner) =>
//                 (learner.fullName || "")
//                   .toLowerCase()
//                   .includes(searchQuery.toLowerCase()) ||
//                 (learner.admissionNumber || "")
//                   .toLowerCase()
//                   .includes(searchQuery.toLowerCase())
//             );
//           }

//           finalLearners.sort((a, b) => {
//             if (sortBy === "name") {
//               return (a.fullName || "").localeCompare(b.fullName || "");
//             }
//             return (a.admissionNumber || "").localeCompare(
//               b.admissionNumber || ""
//             );
//           });

//           setLearners(finalLearners);
//           setMarks(
//             finalLearners.reduce(
//               (acc, learner) => ({
//                 ...acc,
//                 [learner._id]: learner.marks,
//               }),
//               {}
//             )
//           );

//           if (finalLearners.length === 0) {
//             alert(
//               `No learners found for ${className}, Stream: ${stream}${
//                 searchQuery ? " matching search query" : ""
//               }.`
//             );
//           }
//         } catch (error) {
//           console.error("Error fetching results:", error);
//           alert("Failed to fetch learner results");
//           setLearners([]);
//           setMarks({});
//         } finally {
//           setFetchingLearners(false);
//         }
//       };

//       fetchResults();
//     } else {
//       setLearners([]);
//       setMarks({});
//     }
//   }, [
//     stream,
//     term,
//     examType,
//     subject,
//     selectedExamName,
//     allLearners,
//     className,
//     schoolStreams,
//     searchQuery,
//     sortBy,
//   ]);

//   const handleUpdateResults = async () => {
//     if (!className || !subject || !stream || !term || !examType) {
//       alert("Please select all required fields");
//       return;
//     }
//     if (
//       (examType === "Random Exams" || examType === "Other Exams") &&
//       !selectedExamName
//     ) {
//       alert("Please select an exam name");
//       return;
//     }

//     const validResults = Object.entries(marks)
//       .filter(([_, mark]) => mark && !isNaN(mark))
//       .map(([learnerId, mark]) => ({
//         learnerId,
//         results: [
//           {
//             term,
//             examType,
//             subject,
//             marks: parseFloat(mark),
//             ...(examType === "Random Exams" || examType === "Other Exams"
//               ? {
//                   examName:
//                     selectedExamName === "Unnamed" ? null : selectedExamName,
//                 }
//               : {}),
//           },
//         ],
//       }));

//     if (validResults.length === 0) {
//       alert("Please enter at least one valid mark to update");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         "http://localhost:5000/api/schools/update-results/batch",
//         {
//           results: validResults,
//           schoolId,
//         }
//       );
//       if (response.data.success) {
//         alert("Success: Results updated successfully!");
//         navigate(-1);
//       } else {
//         alert(
//           "Error: " + (response.data.message || "Some results failed to update")
//         );
//       }
//     } catch (error) {
//       console.error("Error updating results:", error);
//       alert(
//         "Error: " +
//           (error.response?.data?.message || "Failed to update results")
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteResult = async (learnerId) => {
//     if (
//       window.confirm(
//         "Are you sure you want to delete this student's result for this subject, term, and exam?"
//       )
//     ) {
//       setLoading(true);
//       try {
//         const payload = { learnerId, term, examType, subject };
//         if (examType === "Random Exams" || examType === "Other Exams") {
//           payload.examName =
//             selectedExamName === "Unnamed" ? null : selectedExamName;
//         }
//         const response = await axios.delete(
//           "http://localhost:5000/api/schools/results",
//           { data: payload }
//         );
//         if (response.data.success) {
//           setLearners((prev) =>
//             prev.map((learner) =>
//               learner._id === learnerId ? { ...learner, marks: "" } : learner
//             )
//           );
//           setMarks((prev) => ({ ...prev, [learnerId]: "" }));
//           alert("Success: Result deleted successfully");
//         } else {
//           alert(
//             "Error: " + (response.data.message || "Failed to delete result")
//           );
//         }
//       } catch (error) {
//         console.error("Error deleting result:", error);
//         alert(
//           "Error: " +
//             (error.response?.data?.message || "Failed to delete result")
//         );
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleDeleteAllResults = async () => {
//     if (
//       window.confirm(
//         `Are you sure you want to delete all results for ${className} (${stream}), ${subject}, ${term}, ${examType}${
//           selectedExamName ? ` (${selectedExamName})` : ""
//         }?`
//       )
//     ) {
//       setLoading(true);
//       try {
//         const learnerIds = learners
//           .map((learner) => learner._id)
//           .filter((id) => id);
//         const payload = { learnerIds, term, examType, subject };
//         if (examType === "Random Exams" || examType === "Other Exams") {
//           payload.examName =
//             selectedExamName === "Unnamed" ? null : selectedExamName;
//         }
//         const response = await axios.delete(
//           "http://localhost:5000/api/schools/results/batch",
//           { data: payload }
//         );
//         if (response.data.success) {
//           setLearners((prev) =>
//             prev.map((learner) => ({ ...learner, marks: "" }))
//           );
//           setMarks({});
//           alert("Success: All results deleted successfully");
//         } else {
//           alert(
//             "Error: " + (response.data.message || "Failed to delete results")
//           );
//         }
//       } catch (error) {
//         console.error("Error deleting results:", error);
//         alert(
//           "Error: " +
//             (error.response?.data?.message || "Failed to delete results")
//         );
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   };

//   return (
//     <Container
//       maxWidth="lg"
//       sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//     >
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography
//           variant="h4"
//           sx={{ fontWeight: "bold", color: "#2c3e50", mb: 3 }}
//         >
//           Modify Class Results
//         </Typography>

//         <Box sx={{ mb: 3 }}>
//           <FormControl fullWidth sx={{ mb: 2 }}>
//             <InputLabel>Class</InputLabel>
//             <Select
//               value={className}
//               onChange={(e) => {
//                 setClassName(e.target.value);
//                 setSubject("");
//                 setStream("");
//                 setTerm("Term 1");
//                 setExamType("Opener Exam");
//                 setExamNames([]);
//                 setSelectedExamName("");
//                 setLearners([]);
//                 setAllLearners([]);
//                 setMarks({});
//                 setSchoolStreams({});
//                 setSearchQuery("");
//                 setSortBy("admissionNumber");
//               }}
//               label="Class"
//             >
//               <MenuItem value="">Select a class</MenuItem>
//               {getClasses().map((cls) => (
//                 <MenuItem key={cls} value={cls}>
//                   {cls}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {className && (
//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel>Subject</InputLabel>
//               <Select
//                 value={subject}
//                 onChange={(e) => {
//                   setSubject(e.target.value);
//                   setStream("");
//                   setTerm("Term 1");
//                   setExamType("Opener Exam");
//                   setExamNames([]);
//                   setSelectedExamName("");
//                   setLearners([]);
//                   setMarks({});
//                   setSearchQuery("");
//                   setSortBy("admissionNumber");
//                 }}
//                 label="Subject"
//               >
//                 <MenuItem value="">Select a subject</MenuItem>
//                 {getSubjectsByClass(className).map((sub) => (
//                   <MenuItem key={sub} value={sub}>
//                     {sub}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           {subject && (
//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel>Stream</InputLabel>
//               {fetchingStreams ? (
//                 <CircularProgress size={24} sx={{ m: 2 }} />
//               ) : (
//                 <Select
//                   value={stream}
//                   onChange={(e) => {
//                     setStream(e.target.value);
//                     setTerm("Term 1");
//                     setExamType("Opener Exam");
//                     setExamNames([]);
//                     setSelectedExamName("");
//                     setLearners([]);
//                     setMarks({});
//                     setSearchQuery("");
//                     setSortBy("admissionNumber");
//                   }}
//                   label="Stream"
//                 >
//                   <MenuItem value="">Select a stream</MenuItem>
//                   {Array.isArray(schoolStreams[className]) &&
//                   schoolStreams[className].length > 0 ? (
//                     schoolStreams[className].map((str) => (
//                       <MenuItem key={str} value={str}>
//                         {str}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem value="No Stream">No Stream</MenuItem>
//                   )}
//                 </Select>
//               )}
//             </FormControl>
//           )}

//           {stream && (
//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel>Term</InputLabel>
//               <Select
//                 value={term}
//                 onChange={(e) => {
//                   setTerm(e.target.value);
//                   setExamType("Opener Exam");
//                   setExamNames([]);
//                   setSelectedExamName("");
//                   setLearners([]);
//                   setMarks({});
//                   setSearchQuery("");
//                   setSortBy("admissionNumber");
//                 }}
//                 label="Term"
//               >
//                 <MenuItem value="Term 1">Term 1</MenuItem>
//                 <MenuItem value="Term 2">Term 2</MenuItem>
//                 <MenuItem value="Term 3">Term 3</MenuItem>
//               </Select>
//             </FormControl>
//           )}

//           {term && (
//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel>Exam Type</InputLabel>
//               <Select
//                 value={examType}
//                 onChange={(e) => {
//                   setExamType(e.target.value);
//                   setExamNames([]);
//                   setSelectedExamName("");
//                   setLearners([]);
//                   setMarks({});
//                   setSearchQuery("");
//                   setSortBy("admissionNumber");
//                 }}
//                 label="Exam Type"
//               >
//                 <MenuItem value="Opener Exam">Opener Exam</MenuItem>
//                 <MenuItem value="Midterm Exam">Midterm Exam</MenuItem>
//                 <MenuItem value="End of Term Exam">End of Term Exam</MenuItem>
//                 <MenuItem value="Random Exams">Random Exams</MenuItem>
//                 <MenuItem value="Other Exams">Other Exams</MenuItem>
//               </Select>
//             </FormControl>
//           )}

//           {(examType === "Random Exams" || examType === "Other Exams") && (
//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel>Exam Name</InputLabel>
//               {fetchingExamNames ? (
//                 <CircularProgress size={24} sx={{ m: 2 }} />
//               ) : (
//                 <Select
//                   value={selectedExamName}
//                   onChange={(e) => {
//                     setSelectedExamName(e.target.value);
//                     setLearners([]);
//                     setMarks({});
//                     setSearchQuery("");
//                     setSortBy("admissionNumber");
//                   }}
//                   label="Exam Name"
//                 >
//                   <MenuItem value="">Select an exam name</MenuItem>
//                   {examNames.length > 0 ? (
//                     examNames.map((name) => (
//                       <MenuItem key={name} value={name}>
//                         {name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem value="" disabled>
//                       No exams found
//                     </MenuItem>
//                   )}
//                 </Select>
//               )}
//             </FormControl>
//           )}
//         </Box>

//         {stream && (
//           <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
//             <TextField
//               label="Search by name or admission number"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               variant="outlined"
//               sx={{ flex: 1, minWidth: 200 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <FormControl sx={{ minWidth: 150 }}>
//               <InputLabel>Sort By</InputLabel>
//               <Select
//                 value={sortBy}
//                 onChange={(e) => setSortBy(e.target.value)}
//                 label="Sort By"
//               >
//                 <MenuItem value="admissionNumber">Admission Number</MenuItem>
//                 <MenuItem value="name">Name</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         )}

//         {fetchingLearners ? (
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               mt: 4,
//             }}
//           >
//             <CircularProgress color="primary" />
//             <Typography sx={{ mt: 2, color: "#6200ee" }}>
//               Fetching learners...
//             </Typography>
//           </Box>
//         ) : learners.length > 0 ? (
//           <Box sx={{ mt: 4 }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 2,
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 sx={{ fontWeight: "bold", color: "#2c3e50" }}
//               >
//                 Learners - {className}{" "}
//                 {stream !== "No Stream" ? `(Stream: ${stream})` : ""} -{" "}
//                 {examType}
//                 {selectedExamName ? ` (${selectedExamName})` : ""}
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="error"
//                 startIcon={<Delete />}
//                 onClick={handleDeleteAllResults}
//                 disabled={loading}
//               >
//                 Delete All Results
//               </Button>
//             </Box>
//             <Typography sx={{ color: "#666", mb: 2, fontStyle: "italic" }}>
//               {learners.length} student{learners.length !== 1 ? "s" : ""} found
//             </Typography>
//             {learners.map((learner) => (
//               <motion.div
//                 key={learner._id}
//                 variants={cardVariants}
//                 initial="hidden"
//                 animate="visible"
//               >
//                 <Card sx={{ mb: 2, boxShadow: 3, bgcolor: "#fff" }}>
//                   <CardContent
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                       <Typography
//                         variant="h6"
//                         sx={{ fontWeight: "600", color: "#2c3e50", ml: 2 }}
//                       >
//                         {learner.fullName || "Unknown"}
//                       </Typography>
//                       <Box sx={{ ml: 2 }}>
//                         <Typography sx={{ color: "#666" }}>
//                           Admission: {learner.admissionNumber || "N/A"}
//                         </Typography>
//                         <Typography sx={{ color: "#666" }}>
//                           Class: {learner.class}
//                         </Typography>
//                         {learner.stream && (
//                           <Typography sx={{ color: "#666" }}>
//                             Stream: {learner.stream}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                       <TextField
//                         label="Marks"
//                         value={marks[learner._id] || ""}
//                         onChange={(e) =>
//                           setMarks((prev) => ({
//                             ...prev,
//                             [learner._id]: e.target.value,
//                           }))
//                         }
//                         type="number"
//                         sx={{ width: 120, mr: 2 }}
//                         variant="outlined"
//                       />
//                       <IconButton
//                         color="error"
//                         onClick={() => handleDeleteResult(learner._id)}
//                         disabled={loading || !marks[learner._id]}
//                       >
//                         <Delete />
//                       </IconButton>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </motion.div>
//             ))}
//           </Box>
//         ) : stream &&
//           (examType === "Random Exams" || examType === "Other Exams"
//             ? selectedExamName
//             : true) ? (
//           <Card
//             sx={{
//               mt: 4,
//               p: 3,
//               textAlign: "center",
//               boxShadow: 3,
//               bgcolor: "#fff",
//             }}
//           >
//             <Typography sx={{ fontWeight: "600", color: "#e74c3c", mb: 1 }}>
//               No learners found for {className}, Stream: {stream}
//               {selectedExamName ? `, Exam: ${selectedExamName}` : ""}
//               {searchQuery ? " matching search query" : ""}
//             </Typography>
//             <Typography sx={{ color: "#666" }}>
//               Please check if there are students enrolled in this stream or
//               adjust your search.
//             </Typography>
//           </Card>
//         ) : null}

//         {learners.length > 0 && (
//           <Button
//             variant="contained"
//             sx={{ mt: 3, bgcolor: "#6200ee", width: "100%" }}
//             onClick={handleUpdateResults}
//             disabled={loading}
//           >
//             {loading ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               "Update Results"
//             )}
//           </Button>
//         )}
//       </motion.div>
//     </Container>
//   );
// };

// export default ModifyClassResults;



import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  InputAdornment,
  Grid,
  Paper,
  Alert,
  FormHelperText,
} from "@mui/material";
import { Search, Delete } from "@mui/icons-material";
import axios from "axios";

const ModifyClassResults = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { schoolId } = location.state || {};
  
  // Selection states
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedStream, setSelectedStream] = useState("");
  const [selectedTerm, setSelectedTerm] = useState("Term 1");
  const [selectedExamType, setSelectedExamType] = useState("Opener Exam");
  const [selectedExamName, setSelectedExamName] = useState("");
  
  // Data states
  const [academicYears, setAcademicYears] = useState([]);
  const [examNames, setExamNames] = useState([]);
  const [schoolStreams, setSchoolStreams] = useState({});
  const [learners, setLearners] = useState([]);
  const [allLearners, setAllLearners] = useState([]);
  const [marks, setMarks] = useState({});
  
  // Loading states
  const [loading, setLoading] = useState(false);
  const [fetchingYears, setFetchingYears] = useState(false);
  const [fetchingExamNames, setFetchingExamNames] = useState(false);
  const [fetchingLearners, setFetchingLearners] = useState(false);
  const [fetchingStreams, setFetchingStreams] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  
  // Other states
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("admissionNumber");
  const [error, setError] = useState(null);

  // Get classes list
  const getClasses = () => [
    "PG",
    "PP1",
    "PP2",
    "Grade 1",
    "Grade 2",
    "Grade 3",
    "Grade 4",
    "Grade 5",
    "Grade 6",
    "Grade 7",
    "Grade 8",
    "Grade 9",
    "Grade 10",
    "Grade 11",
    "Grade 12",
  ];

  // Get subjects by class
  const getSubjectsByClass = (className) => {
    if (["PG"].includes(className)) {
      return [
        "Number Work",
        "Language/Total",
        "Reading/Jumla",
        "Creative",
        "Science and Environment",
        "Social Studies and Religious Education",
      ];
    }

    if (["PP1", "PP2"].includes(className)) {
      return [
        "Number Work",
        "Language/Total",
        "Kiswahili/Jumla",
        "Creative Arts",
        "Science and Environment",
        "Social Studies and Religious Education",
      ];
    } else if (["Grade 1", "Grade 2", "Grade 3"].includes(className)) {
      return [
        "English",
        "Kiswahili",
        "Mathematics",
        "Science",
        "Social Studies and Religious Education",
        "Environmental Activities",
      ];
    } else if (["Grade 4", "Grade 5", "Grade 6"].includes(className)) {
      return [
        "English Language",
        "English Composition",
        "Kiswahili Lugha",
        "Kiswahili Insha",
        "Mathematics",
        "Science and Technology",
        "Agriculture and Nutrition",
        "Social Studies",
        "Religious Education",
        "Creative Arts & Sports",
      ];
    } else if (["Grade 7", "Grade 8", "Grade 9"].includes(className)) {
      return [
        "English Language",
        "English Composition",
        "Kiswahili Lugha",
        "Kiswahili Insha",
        "Mathematics",
        "Science",
        "Science and Technology",
        "Agriculture and Nutrition",
        "Pre-Technical Studies",
        "Social Studies",
        "Religious Education",
        "Creative Arts & Sports",
      ];
    } else if (["Grade 10", "Grade 11", "Grade 12"].includes(className)) {
      return [
        "English",
        "Kiswahili Language/Kenya Sign Language",
        "Mathematics",
        "Religious Education",
        "Science and Technology",
        "Agriculture and Nutrition",
        "Social Studies",
      ];
    }
    return [];
  };

  // Fetch available academic years on component mount
  useEffect(() => {
    if (!schoolId) {
      setError("School information not available");
      return;
    }

    const fetchAvailableYears = async () => {
      setFetchingYears(true);
      try {
        const response = await axios.get(
          `https://ed-9ny1.onrender.com/api/schools/${schoolId}/performance/years`
        );
        setAcademicYears(response.data);

        // Auto-select the most recent year
        if (response.data.length > 0) {
          setSelectedYear(response.data[0]);
        }
        setInitialLoad(false);
      } catch (err) {
        console.error("Error fetching academic years:", err);
        setError("Failed to load academic years");
        setInitialLoad(false);
      } finally {
        setFetchingYears(false);
      }
    };

    fetchAvailableYears();
  }, [schoolId]);

  // Fetch streams when class changes
  useEffect(() => {
    if (selectedClass && selectedYear) {
      const fetchStreams = async () => {
        setFetchingStreams(true);
        try {
          const streamsResponse = await axios.get(
            `https://ed-9ny1.onrender.com/api/schools/${schoolId}/streams`
          );
          if (streamsResponse.data?.classStreams) {
            setSchoolStreams(streamsResponse.data.classStreams);
          } else {
            setSchoolStreams({});
          }
        } catch (error) {
          console.error("Error fetching streams:", error);
          setError("Failed to fetch streams");
          setSchoolStreams({});
        } finally {
          setFetchingStreams(false);
        }
      };
      fetchStreams();
    } else {
      setSchoolStreams({});
    }
  }, [selectedClass, schoolId, selectedYear]);

  // Fetch all learners when class is selected
  useEffect(() => {
    if (selectedClass && selectedYear) {
      const fetchAllLearners = async () => {
        setFetchingLearners(true);
        try {
          const response = await axios.get(
            "https://ed-9ny1.onrender.com/api/schools/learners",
            {
              params: { schoolId, className: selectedClass },
            }
          );
          if (Array.isArray(response.data)) {
            setAllLearners(
              response.data.filter(
                (learner) => learner && learner._id && learner.class
              )
            );
          } else {
            setAllLearners([]);
          }
        } catch (error) {
          console.error("Error fetching learners:", error);
          setError("Failed to fetch learners");
          setAllLearners([]);
        } finally {
          setFetchingLearners(false);
        }
      };
      fetchAllLearners();
    } else {
      setAllLearners([]);
    }
  }, [selectedClass, schoolId, selectedYear]);

  // Fetch exam names when exam type changes
  useEffect(() => {
    if (selectedYear && selectedClass && selectedTerm && selectedExamType) {
      const fetchExamNames = async () => {
        setFetchingExamNames(true);
        try {
          const response = await axios.get(
            `https://ed-9ny1.onrender.com/api/schools/${schoolId}/performance/exam-names`,
            {
              params: {
                class: selectedClass,
                term: selectedTerm,
                examType: selectedExamType,
                academicYear: selectedYear,
              },
            }
          );

          // If no exam names found, add "Unnamed" option
          let examNames = response.data;
          if (
            examNames.length === 0 &&
            selectedExamType !== "Random Exams" &&
            selectedExamType !== "Other Exams"
          ) {
            examNames = ["Unnamed"];
          }

          setExamNames(examNames);
          setSelectedExamName(examNames.length > 0 ? examNames[0] : "");
        } catch (err) {
          console.error("Error fetching exam names:", err);
          setExamNames([]);
          setSelectedExamName("");
        } finally {
          setFetchingExamNames(false);
        }
      };

      fetchExamNames();
    } else {
      setExamNames([]);
      setSelectedExamName("");
    }
  }, [selectedExamType, selectedYear, selectedClass, selectedTerm, schoolId]);

  // Fetch results when all criteria are selected
  useEffect(() => {
    if (
      selectedStream &&
      selectedTerm &&
      selectedExamType &&
      selectedSubject &&
      selectedYear &&
      Array.isArray(allLearners) &&
      allLearners.length > 0 &&
      (selectedExamType === "Random Exams" || selectedExamType === "Other Exams"
        ? selectedExamName
        : true)
    ) {
      const hasStreams = schoolStreams[selectedClass]?.length > 0;
      let filteredLearners = allLearners.filter(
        (learner) => learner.class === selectedClass
      );
      
      if (hasStreams) {
        if (selectedStream === "No Stream") {
          filteredLearners = filteredLearners.filter(
            (learner) => !learner.stream || learner.stream.trim() === ""
          );
        } else {
          filteredLearners = filteredLearners.filter(
            (learner) => learner.stream === selectedStream
          );
        }
      }

      const fetchResults = async () => {
        setFetchingLearners(true);
        try {
          const learnerIds = filteredLearners
            .map((learner) => learner._id)
            .filter((id) => id);
          
          if (learnerIds.length === 0) {
            setLearners([]);
            setMarks({});
            setError("No learners found for the selected criteria.");
            return;
          }
          
          const payload = { 
            learnerIds, 
            term: selectedTerm, 
            examType: selectedExamType, 
            subject: selectedSubject,
            academicYear: selectedYear 
          };
          
          if (selectedExamType === "Random Exams" || selectedExamType === "Other Exams") {
            payload.examName =
              selectedExamName === "Unnamed" ? null : selectedExamName;
          }
          
          const response = await axios.post(
            "https://ed-9ny1.onrender.com/api/schools/results/class",
            payload
          );
          
          const results = Array.isArray(response.data.results)
            ? response.data.results
            : [];

          const learnersWithResults = filteredLearners.map((learner) => {
            const learnerResult = results.find(
              (r) => r.learnerId === learner._id
            );
            return {
              ...learner,
              marks:
                learnerResult && learnerResult.marks != null
                  ? learnerResult.marks.toString()
                  : "",
            };
          });

          let finalLearners = learnersWithResults;
          if (searchQuery) {
            finalLearners = finalLearners.filter(
              (learner) =>
                (learner.fullName || "")
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()) ||
                (learner.admissionNumber || "")
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
            );
          }

          finalLearners.sort((a, b) => {
            if (sortBy === "name") {
              return (a.fullName || "").localeCompare(b.fullName || "");
            }
            return (a.admissionNumber || "").localeCompare(
              b.admissionNumber || ""
            );
          });

          setLearners(finalLearners);
          setMarks(
            finalLearners.reduce(
              (acc, learner) => ({
                ...acc,
                [learner._id]: learner.marks,
              }),
              {}
            )
          );

          if (finalLearners.length === 0) {
            setError(
              `No learners found for ${selectedClass}, Stream: ${selectedStream}${
                searchQuery ? " matching search query" : ""
              }.`
            );
          } else {
            setError(null);
          }
        } catch (error) {
          console.error("Error fetching results:", error);
          setError("Failed to fetch learner results");
          setLearners([]);
          setMarks({});
        } finally {
          setFetchingLearners(false);
        }
      };

      fetchResults();
    } else {
      setLearners([]);
      setMarks({});
    }
  }, [
    selectedStream,
    selectedTerm,
    selectedExamType,
    selectedSubject,
    selectedExamName,
    selectedYear,
    allLearners,
    selectedClass,
    schoolStreams,
    searchQuery,
    sortBy,
  ]);

  const handleUpdateResults = async () => {
    if (!selectedClass || !selectedSubject || !selectedStream || !selectedTerm || !selectedExamType || !selectedYear) {
      setError("Please select all required fields");
      return;
    }
    
    if (
      (selectedExamType === "Random Exams" || selectedExamType === "Other Exams") &&
      !selectedExamName
    ) {
      setError("Please select an exam name");
      return;
    }

    const validResults = Object.entries(marks)
      .filter(([_, mark]) => mark && !isNaN(mark))
      .map(([learnerId, mark]) => ({
        learnerId,
        results: [
          {
            term: selectedTerm,
            examType: selectedExamType,
            subject: selectedSubject,
            marks: parseFloat(mark),
            academicYear: selectedYear,
            ...(selectedExamType === "Random Exams" || selectedExamType === "Other Exams"
              ? {
                  examName:
                    selectedExamName === "Unnamed" ? null : selectedExamName,
                }
              : {}),
          },
        ],
      }));

    if (validResults.length === 0) {
      setError("Please enter at least one valid mark to update");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://ed-9ny1.onrender.com/api/schools/update-results/batch",
        {
          results: validResults,
          schoolId,
        }
      );
      
      if (response.data.success) {
        alert("Success: Results updated successfully!");
        navigate(-1);
      } else {
        setError("Error: " + (response.data.message || "Some results failed to update"));
      }
    } catch (error) {
      console.error("Error updating results:", error);
      setError(
        "Error: " +
          (error.response?.data?.message || "Failed to update results")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteResult = async (learnerId) => {
    if (
      window.confirm(
        "Are you sure you want to delete this student's result for this subject, term, and exam?"
      )
    ) {
      setLoading(true);
      try {
        const payload = { 
          learnerId, 
          term: selectedTerm, 
          examType: selectedExamType, 
          subject: selectedSubject,
          academicYear: selectedYear 
        };
        
        if (selectedExamType === "Random Exams" || selectedExamType === "Other Exams") {
          payload.examName =
            selectedExamName === "Unnamed" ? null : selectedExamName;
        }
        
        const response = await axios.delete(
          "https://ed-9ny1.onrender.com/api/schools/results",
          { data: payload }
        );
        
        if (response.data.success) {
          setLearners((prev) =>
            prev.map((learner) =>
              learner._id === learnerId ? { ...learner, marks: "" } : learner
            )
          );
          setMarks((prev) => ({ ...prev, [learnerId]: "" }));
          alert("Success: Result deleted successfully");
        } else {
          setError("Error: " + (response.data.message || "Failed to delete result"));
        }
      } catch (error) {
        console.error("Error deleting result:", error);
        setError(
          "Error: " +
            (error.response?.data?.message || "Failed to delete result")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDeleteAllResults = async () => {
    if (
      window.confirm(
        `Are you sure you want to delete all results for ${selectedClass} (${selectedStream}), ${selectedSubject}, ${selectedTerm}, ${selectedExamType}${
          selectedExamName ? ` (${selectedExamName})` : ""
        }, ${selectedYear}?`
      )
    ) {
      setLoading(true);
      try {
        const learnerIds = learners
          .map((learner) => learner._id)
          .filter((id) => id);
        
        const payload = { 
          learnerIds, 
          term: selectedTerm, 
          examType: selectedExamType, 
          subject: selectedSubject,
          academicYear: selectedYear 
        };
        
        if (selectedExamType === "Random Exams" || selectedExamType === "Other Exams") {
          payload.examName =
            selectedExamName === "Unnamed" ? null : selectedExamName;
        }
        
        const response = await axios.delete(
          "https://ed-9ny1.onrender.com/api/schools/results/batch",
          { data: payload }
        );
        
        if (response.data.success) {
          setLearners((prev) =>
            prev.map((learner) => ({ ...learner, marks: "" }))
          );
          setMarks({});
          alert("Success: All results deleted successfully");
        } else {
          setError("Error: " + (response.data.message || "Failed to delete results"));
        }
      } catch (error) {
        console.error("Error deleting results:", error);
        setError(
          "Error: " +
            (error.response?.data?.message || "Failed to delete results")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const resetSelections = () => {
    setSelectedYear(academicYears[0] || "");
    setSelectedClass("");
    setSelectedSubject("");
    setSelectedStream("");
    setSelectedTerm("Term 1");
    setSelectedExamType("Opener Exam");
    setSelectedExamName("");
    setLearners([]);
    setMarks({});
    setAllLearners([]);
    setSchoolStreams({});
    setSearchQuery("");
    setSortBy("admissionNumber");
    setError(null);
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", color: "#2c3e50", mb: 3 }}
        >
          Modify Class Results
        </Typography>

        {/* Selection Form - Similar to SchoolPerformance */}
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 3 }}>
            Select Criteria
          </Typography>

          <Grid container spacing={2}>
            {/* Academic Year */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth>
                <InputLabel>Academic Year</InputLabel>
                <Select
                  value={selectedYear}
                  onChange={(e) => {
                    setSelectedYear(e.target.value);
                    setSelectedClass("");
                    setSelectedSubject("");
                    setSelectedStream("");
                    setSelectedTerm("Term 1");
                    setSelectedExamType("Opener Exam");
                    setSelectedExamName("");
                    setLearners([]);
                    setMarks({});
                    setError(null);
                  }}
                  label="Academic Year"
                  disabled={fetchingYears || initialLoad}
                >
                  <MenuItem value="">Select Year</MenuItem>
                  {academicYears.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
                {fetchingYears && (
                  <CircularProgress size={20} sx={{ mt: 1 }} />
                )}
              </FormControl>
            </Grid>

            {/* Class */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth disabled={!selectedYear}>
                <InputLabel>Class</InputLabel>
                <Select
                  value={selectedClass}
                  onChange={(e) => {
                    setSelectedClass(e.target.value);
                    setSelectedSubject("");
                    setSelectedStream("");
                    setSelectedTerm("Term 1");
                    setSelectedExamType("Opener Exam");
                    setSelectedExamName("");
                    setLearners([]);
                    setMarks({});
                    setError(null);
                  }}
                  label="Class"
                >
                  <MenuItem value="">Select Class</MenuItem>
                  {getClasses().map((cls) => (
                    <MenuItem key={cls} value={cls}>
                      {cls}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Subject */}
            {selectedClass && (
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Subject</InputLabel>
                  <Select
                    value={selectedSubject}
                    onChange={(e) => {
                      setSelectedSubject(e.target.value);
                      setSelectedStream("");
                      setSelectedTerm("Term 1");
                      setSelectedExamType("Opener Exam");
                      setSelectedExamName("");
                      setLearners([]);
                      setMarks({});
                      setError(null);
                    }}
                    label="Subject"
                  >
                    <MenuItem value="">Select Subject</MenuItem>
                    {getSubjectsByClass(selectedClass).map((sub) => (
                      <MenuItem key={sub} value={sub}>
                        {sub}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Stream */}
            {selectedSubject && (
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Stream</InputLabel>
                  {fetchingStreams ? (
                    <CircularProgress size={24} sx={{ m: 2 }} />
                  ) : (
                    <Select
                      value={selectedStream}
                      onChange={(e) => {
                        setSelectedStream(e.target.value);
                        setSelectedTerm("Term 1");
                        setSelectedExamType("Opener Exam");
                        setSelectedExamName("");
                        setLearners([]);
                        setMarks({});
                        setError(null);
                      }}
                      label="Stream"
                    >
                      <MenuItem value="">Select Stream</MenuItem>
                      {Array.isArray(schoolStreams[selectedClass]) &&
                      schoolStreams[selectedClass].length > 0 ? (
                        schoolStreams[selectedClass].map((str) => (
                          <MenuItem key={str} value={str}>
                            {str}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="No Stream">No Stream</MenuItem>
                      )}
                    </Select>
                  )}
                </FormControl>
              </Grid>
            )}

            {/* Term */}
            {selectedStream && (
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Term</InputLabel>
                  <Select
                    value={selectedTerm}
                    onChange={(e) => {
                      setSelectedTerm(e.target.value);
                      setSelectedExamType("Opener Exam");
                      setSelectedExamName("");
                      setLearners([]);
                      setMarks({});
                      setError(null);
                    }}
                    label="Term"
                  >
                    <MenuItem value="Term 1">Term 1</MenuItem>
                    <MenuItem value="Term 2">Term 2</MenuItem>
                    <MenuItem value="Term 3">Term 3</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Exam Type */}
            {selectedTerm && (
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Exam Type</InputLabel>
                  <Select
                    value={selectedExamType}
                    onChange={(e) => {
                      setSelectedExamType(e.target.value);
                      setSelectedExamName("");
                      setLearners([]);
                      setMarks({});
                      setError(null);
                    }}
                    label="Exam Type"
                  >
                    <MenuItem value="Opener Exam">Opener Exam</MenuItem>
                    <MenuItem value="Midterm Exam">Midterm Exam</MenuItem>
                    <MenuItem value="End of Term Exam">End of Term Exam</MenuItem>
                    <MenuItem value="Random Exams">Random Exams</MenuItem>
                    <MenuItem value="Other Exams">Other Exams</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Exam Name */}
            {selectedExamType && (
              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  fullWidth
                  disabled={!selectedExamType || fetchingExamNames}
                >
                  <InputLabel>Exam Name</InputLabel>
                  <Select
                    value={selectedExamName}
                    onChange={(e) => {
                      setSelectedExamName(e.target.value);
                      setLearners([]);
                      setMarks({});
                      setError(null);
                    }}
                    label="Exam Name"
                  >
                    <MenuItem value="">Select Exam Name</MenuItem>
                    {fetchingExamNames ? (
                      <MenuItem value="" disabled>
                        <CircularProgress size={20} />
                        Loading...
                      </MenuItem>
                    ) : (
                      examNames.map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  {selectedExamType &&
                    !fetchingExamNames &&
                    examNames.length === 0 && (
                      <FormHelperText>
                        No specific exam names found
                      </FormHelperText>
                    )}
                </FormControl>
              </Grid>
            )}
          </Grid>

          {/* Error Display */}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </Paper>

        {/* Search and Sort Controls */}
        {selectedStream && (
          <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
            <TextField
              label="Search by name or admission number"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              variant="outlined"
              sx={{ flex: 1, minWidth: 200 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl sx={{ minWidth: 150 }}>
              <InputLabel>Sort By</InputLabel>
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                label="Sort By"
              >
                <MenuItem value="admissionNumber">Admission Number</MenuItem>
                <MenuItem value="name">Name</MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}

        {/* Loading State */}
        {fetchingLearners ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 4,
            }}
          >
            <CircularProgress color="primary" />
            <Typography sx={{ mt: 2, color: "#6200ee" }}>
              Fetching learners...
            </Typography>
          </Box>
        ) : learners.length > 0 ? (
          <Box sx={{ mt: 4 }}>
            {/* Header with Delete All Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#2c3e50" }}
              >
                Learners - {selectedClass}{" "}
                {selectedStream !== "No Stream" ? `(Stream: ${selectedStream})` : ""} -{" "}
                {selectedExamType}
                {selectedExamName ? ` (${selectedExamName})` : ""} - {selectedYear}
              </Typography>
              <Button
                variant="contained"
                color="error"
                startIcon={<Delete />}
                onClick={handleDeleteAllResults}
                disabled={loading}
              >
                Delete All Results
              </Button>
            </Box>
            
            <Typography sx={{ color: "#666", mb: 2, fontStyle: "italic" }}>
              {learners.length} student{learners.length !== 1 ? "s" : ""} found
            </Typography>
            
            {/* Learners List */}
            {learners.map((learner) => (
              <motion.div
                key={learner._id}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
              >
                <Card sx={{ mb: 2, boxShadow: 3, bgcolor: "#fff" }}>
                  <CardContent
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "600", color: "#2c3e50", ml: 2 }}
                      >
                        {learner.fullName || "Unknown"}
                      </Typography>
                      <Box sx={{ ml: 2 }}>
                        <Typography sx={{ color: "#666" }}>
                          Admission: {learner.admissionNumber || "N/A"}
                        </Typography>
                        <Typography sx={{ color: "#666" }}>
                          Class: {learner.class}
                        </Typography>
                        {learner.stream && (
                          <Typography sx={{ color: "#666" }}>
                            Stream: {learner.stream}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        label="Marks"
                        value={marks[learner._id] || ""}
                        onChange={(e) =>
                          setMarks((prev) => ({
                            ...prev,
                            [learner._id]: e.target.value,
                          }))
                        }
                        type="number"
                        sx={{ width: 120, mr: 2 }}
                        variant="outlined"
                      />
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteResult(learner._id)}
                        disabled={loading || !marks[learner._id]}
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </Box>
        ) : selectedStream &&
          (selectedExamType === "Random Exams" || selectedExamType === "Other Exams"
            ? selectedExamName
            : true) ? (
          <Card
            sx={{
              mt: 4,
              p: 3,
              textAlign: "center",
              boxShadow: 3,
              bgcolor: "#fff",
            }}
          >
            <Typography sx={{ fontWeight: "600", color: "#e74c3c", mb: 1 }}>
              No learners found for {selectedClass}, Stream: {selectedStream}, {selectedYear}
              {selectedExamName ? `, Exam: ${selectedExamName}` : ""}
              {searchQuery ? " matching search query" : ""}
            </Typography>
            <Typography sx={{ color: "#666" }}>
              Please check if there are students enrolled in this stream or adjust your search.
            </Typography>
          </Card>
        ) : null}

        {/* Update Results Button */}
        {learners.length > 0 && (
          <Button
            variant="contained"
            sx={{ mt: 3, bgcolor: "#6200ee", width: "100%" }}
            onClick={handleUpdateResults}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Update Results"
            )}
          </Button>
        )}
      </motion.div>
    </Container>
  );
};

export default ModifyClassResults;